interface IAccountStatus {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
}

export const TRADING_ACCOUNT_STATUS: IAccountStatus = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
};
